<template>
  <button v-bind:class="{ on: active }" @click="click()">
    <v-icon large :color="active ? iconColor : ''" class="neon" :style="iColor">{{
      icon
    }}</v-icon
    ><br />
    <label class="text-caption">{{ label }}</label>
  </button>
</template>

<script>
export default {
  props: {
    active: Boolean,
    icon: String,
    label: String,
    iconColor: String,
  },
  computed: {
    iColor() {
      return {
        '--i-color': this.iconColor,
      }
    }
  },
  methods: {
    click() {
      this.$emit("click", !this.active);
    },
  },
};
</script>

<style scoped>
button {
  width: 5em;
  height: 5em;
  background: #efefef;
  border: none;
  border-radius: 0.5rem;
  font-weight: 700;
  letter-spacing: 0.1rem;
  text-align: center;
  outline: none;
  cursor: pointer;
  transition: 0.2s ease-in-out;
  box-shadow: -6px -6px 14px rgba(255, 255, 255, 0.7),
    -6px -6px 10px rgba(255, 255, 255, 0.5),
    6px 6px 8px rgba(255, 255, 255, 0.075), 6px 6px 10px rgba(0, 0, 0, 0.15);
}
button:active {
  box-shadow: inset -2px -2px 6px rgba(255, 255, 255, .7),
              inset -2px -2px 4px rgba(255, 255, 255, .5),
              inset 2px 2px 2px rgba(255, 255, 255, .075),
              inset 2px 2px 4px rgba(0, 0, 0, .15);
}
.on {
  box-shadow: inset -2px -2px 6px rgba(255, 255, 255, 0.7),
    inset -2px -2px 4px rgba(255, 255, 255, 0.5),
    inset 2px 2px 2px rgba(255, 255, 255, 0.075),
    inset 2px 2px 4px rgba(0, 0, 0, 0.15);
}
.on > .neon {
  filter: drop-shadow(0 0 0.8rem var(--i-color));
}
</style>